/**
 * Created by torugo on 28/04/2017.
 */
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  }            from "@angular/core";
import { CommonModule }        from "@angular/common";
import { ReactiveFormsModule,FormsModule } from "@angular/forms";
import { GameEventComponent }   from './gameevent.component';
import {GameEventRoutingModule} from './gameevent.routing'
import {RouterModule} from "@angular/router";
import { TextMaskModule } from 'angular2-text-mask';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { TeleEventMidiaComponent } from "./midia/teleevent-midia-component";
import { EmojiModalComponent } from "./emojis-modal/emojis-modal-component";
import { CellphoneModalComponent} from "./cellphone-modal/cellphone-component";
import { AppScreenComponent} from "./cellphone-modal/app-screen/appscreen-component";
import { ContactScreenComponent} from "./cellphone-modal/contact-screen/contact-screen-component";
import { RoomUserScreenComponent} from "./cellphone-modal/room-user-screen/room-user-screen-component";
import { NotificationsScreenComponent} from "./cellphone-modal/notifications-screen/notifications-screen-component";

import { WritScreenComponent} from "./cellphone-modal/writ-screen/writ-screen";
import { CheckListComponent} from "./cellphone-modal/+checklist/checklist.component";
import { CalendarScreenComponent} from "./cellphone-modal/calendar/calendar-screen";
import { IframeScreenComponent} from "./cellphone-modal/iframe-screen/iframe-screen";
import { FavoriteRoomScreenComponent} from "./cellphone-modal/favorite-room-screen/favorite-room-screen";
import { GalleryScreenComponent} from "./cellphone-modal/gallery-screen/gallery-screen-component";
import { ChatScreenComponent} from "./cellphone-modal/chat-screen/chat.component";
import { ProfileScreenComponent} from "./cellphone-modal/profile-screen/profile-screen";
import { LevelScreenComponent} from "./cellphone-modal/level-screen/level-screen";
import { VideoconferenceScreenComponent} from "./cellphone-modal/videoconference-screen/videconference-screen";
import { SeminarQuestionsComponent} from "./cellphone-modal/seminar-questions/seminar-questions-component";
import { NotifyComponent} from "./cellphone-modal/notify/notify-component";
import { EditObjectComponent} from "./edit-object-modal/edit-object-component";
import { RoomMediaControlComponent} from "./room-media-control/room-media-component";
import { UserInteractionModal} from "./user-interaction-modal/user-interaction-modal";
import {UserOnEventComponent} from "./cellphone-modal/user-on-event/user-on-event";
import {PayTerrainModalComponent} from "./pay-terrain/payterrain-component"

import { EditRoomComponent} from "./edit-room-modal/edit-room-component";
import { ExternalLinkModal} from "./external-link-modal/external-link-modal";
import { RoomItemModal} from "./room-item-modal/room-item-modal";

import { ComunicationModule } from "../../comunication-module";
import { NpcModalComponent} from "./npc-modal/npc-modal-component";
import { NpcChatbotComponent} from "./npc-modal/npc-chatbot-component";

import { TradeModalComponent} from "./trade/trade-modal";

import { MovieListModal} from "./movie-list-modal/movie-list-modal";
import { ContainerModal} from "./container/container-modal";
import { MemoryContainerModal} from "./container/memory-container-modal";
import { PaintContainerModal } from "./container/paint-container";

import { TrelloContainerModal} from "./container/trello-container-modal";


import { CalendarModal} from "./calendar/calendar-modal";
import { VendorModal} from "./vendor/vendor-modal";
import { SkillsModal} from "./skills/skills-modal";
import { CraftModal} from "./craft-menu/craft-menu-modal";
import { ItemManipulationModal} from "./item-manipulation/item-manipulation-modal";

import {TranslateModule} from '../../translate-module';
import { EasyLoginModule } from "../+easylogin/easylogin.module";

import { TriggerModule } from "./triggers/trigger.module";


import { EventComponent } from "./event.component";
import { TutorialComponent } from "./tutorial/tutorial"
import { MeetingEventComponent } from "./meeting.event.component";

import { SpeakerRoomComponent} from "./speaker.room.component"
import { EventDashboardComponent} from "./event.dashboard.component"

import { MapEventComponent} from "./map.event.component"

import {MouseFollowModal} from './gameswithingames/mouse-follow-game'
import { MediaModalComponent } from "./mediaModal/mediaModal";
@NgModule({
    imports : [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      TriggerModule,
      GameEventRoutingModule,
      RouterModule,
      TextMaskModule,
      NguiAutoCompleteModule,
      ComunicationModule,
      TranslateModule,
    ],
    declarations : [
      UserOnEventComponent,
      SpeakerRoomComponent,
      EventDashboardComponent,
      MapEventComponent,
        GameEventComponent,
        EventComponent,
        MeetingEventComponent,
        EmojiModalComponent,
        TeleEventMidiaComponent,
        CellphoneModalComponent,
        AppScreenComponent,
        ContactScreenComponent,
        RoomUserScreenComponent,
        GalleryScreenComponent,
        CheckListComponent,
        WritScreenComponent,
        IframeScreenComponent,
        ChatScreenComponent,
        NotificationsScreenComponent,
        CalendarScreenComponent,
        FavoriteRoomScreenComponent,
        RoomMediaControlComponent,
        SeminarQuestionsComponent,
        ProfileScreenComponent,
        LevelScreenComponent,
        NotifyComponent,
        VideoconferenceScreenComponent,
        EditObjectComponent,
        EditRoomComponent,
        NpcModalComponent,
        NpcChatbotComponent,
        ExternalLinkModal,
        MovieListModal,
        ContainerModal,
        MemoryContainerModal,
        TrelloContainerModal,
        SkillsModal,
        CraftModal,
        ItemManipulationModal,
        MediaModalComponent,
        UserInteractionModal,
        TutorialComponent,
        CalendarModal,
        VendorModal,
        RoomItemModal,
        PaintContainerModal,
        MouseFollowModal,
        TradeModalComponent,
        PayTerrainModalComponent,
    ],
    exports:[
      GameEventComponent
    ],
    providers : [
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class GameEventModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/gameevent.module.ts